/* Height pillar (sections/height-pillar.liquid): the two Read more panels, the Before you choose tabs, the
   kitchen island / bar counter toggle and the How many fit slider. The stool finder itself is pillar.js.
   Every panel is in the HTML with hidden="until-found", so find-in-page opens it too. */
(function () {
  if (window.__heightPillar) return;
  window.__heightPillar = true;
  var KNOW_IDS = ['height', 'how-many', 'backrest', 'material', 'upholstery'];

  function ev(name, p) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p || {})); }
  function hide(el) { el.setAttribute('hidden', 'until-found'); }

  function setPanel(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    if (open) panel.removeAttribute('hidden'); else hide(panel);
    btn.setAttribute('aria-expanded', String(open));
    var lab = btn.querySelector('[data-hpl-label]');
    if (lab) lab.textContent = open ? btn.getAttribute('data-close') : btn.getAttribute('data-open');
  }
  function toggleFor(panelId) { return document.querySelector('[data-hpl-toggle][aria-controls="' + panelId + '"]'); }
  function openPanel(panelId) { var b = toggleFor(panelId); if (b) setPanel(b, true); }

  function selectTab(tab, focus) {
    var list = tab.closest('[role="tablist"]'), root = tab.closest('[data-hpk]');
    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) { if (on) p.removeAttribute('hidden'); else hide(p); }
    });
    if (focus) tab.focus();
    if (window.matchMedia('(max-width: 767px)').matches) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  function showKnow(id) {
    openPanel('know');
    var tab = document.getElementById('hpk-tab-' + id);
    if (tab) selectTab(tab, false);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hpl-toggle]');
    if (b) {
      var open = b.getAttribute('aria-expanded') !== 'true';
      setPanel(b, open);
      if (open) ev('pillar_panel_open', { panel: b.getAttribute('aria-controls') });
      return;
    }
    var t = e.target.closest('.hpk__tab');
    if (t) { selectTab(t, false); ev('know_tab', { anchor: t.getAttribute('aria-controls'), source: 'click' }); return; }
    var m = e.target.closest('[data-hpk-mode]');
    if (m) {
      var card = m.closest('[data-hpk-height]'), mode = m.getAttribute('data-hpk-mode');
      card.querySelectorAll('[data-hpk-mode]').forEach(function (x) { x.setAttribute('aria-checked', String(x === m)); });
      card.querySelectorAll('[data-hpk-fig]').forEach(function (f) { f.hidden = f.getAttribute('data-hpk-fig') !== mode; });
      var st = card.querySelector('[data-hpk-st]'); if (st) st.textContent = st.getAttribute('data-' + mode);
      return;
    }
    var f = e.target.closest('[data-hpk-find]');
    if (f) {
      e.preventDefault();
      openPanel('find');
      var target = document.getElementById('find');
      if (target) {
        var head = 80, smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - head, behavior: smooth ? 'smooth' : 'auto' });
        var first = target.querySelector('.hpl__opt'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.hpk__tab');
    if (!t) return;
    var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (!d) return;
    e.preventDefault();
    var tabs = [].slice.call(t.closest('[role="tablist"]').querySelectorAll('[role="tab"]'));
    selectTab(tabs[(tabs.indexOf(t) + d + tabs.length) % tabs.length], true);
  });

  /* Find in page reveals a hidden panel: keep the buttons and tabs in step */
  document.addEventListener('beforematch', function (e) {
    var el = e.target;
    if (el.matches('[data-hpl-panel]')) { var b = toggleFor(el.id); if (b) setPanel(b, true); }
    else if (el.matches('.hpk__panel')) { openPanel('know'); var tab = document.getElementById('hpk-tab-' + el.id); if (tab) selectTab(tab, false); }
  }, true);

  /* How many fit */
  document.addEventListener('input', function (e) {
    var s = e.target.closest && e.target.closest('[data-hpk-slider]');
    if (!s) return;
    var card = s.closest('[data-hpk-count]'), L = +s.value;
    var std = +card.getAttribute('data-std') || 55, slim = +card.getAttribute('data-slim') || 50;
    var n = Math.floor(L / std), ns = Math.floor(L / slim);
    var st = card.querySelector('[data-hpk-cst]'), line = card.querySelector('[data-hpk-cline]'), len = card.querySelector('[data-hpk-clen]');
    var inch = st.getAttribute('data-unit') === 'in';
    var Ls = inch ? (Math.round(L / 2.54 * 2) / 2) + ' in' : L + ' cm';
    var tpl = n === 1 ? st.getAttribute('data-tpl-one') : st.getAttribute('data-tpl');
    st.textContent = tpl.replace('%n', n).replace('%l cm', Ls).replace('%l', L);
    line.textContent = ns > n ? line.getAttribute('data-more').replace('%s', ns) : line.getAttribute('data-same');
    if (len) len.textContent = Ls;
    s.style.setProperty('--fill', ((L - s.min) / (s.max - s.min) * 100) + '%');
  });
  function initSliders() {
    document.querySelectorAll('[data-hpk-slider]').forEach(function (s) { s.style.setProperty('--fill', ((s.value - s.min) / (s.max - s.min) * 100) + '%'); });
  }

  /* A link to a panel opens it: #find, #know, or one of the five topics */
  function fromHash() {
    var id = location.hash.slice(1);
    if (!id) return;
    if (id === 'find' || id === 'know') { openPanel(id); return; }
    if (KNOW_IDS.indexOf(id) > -1 || document.getElementById('hpk-tab-' + id)) showKnow(id);
  }
  function init() { initSliders(); fromHash(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('hashchange', fromHash);
  document.addEventListener('shopify:section:load', initSliders);
})();
